import { Components, Theme } from '@mui/material';

export const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: {
      borderBottom: '1px solid rgba(98, 111, 136, 0.56)',
    },
  },
};
